import React, { useState } from 'react';
import './SeasonalPopup.css';

const BATCHES = [
  'July 6 – 10, 2026',
  'July 13 – 17, 2026',
  'July 20 – 24, 2026',
  'July 27 – 31, 2026',
  'Aug 3 – 7, 2026',
  'Aug 10 – 14, 2026',
  'Aug 17 – 21, 2026',
  'Aug 24 – 28, 2026',
];

const COURSES = [
  { age: 'Age 6+',          title: 'Dog Bot & Cradle Bot', level: 'Beginner' },
  { age: 'Age 8+ Basic',    title: 'Walking Bot',          level: 'Intermediate' },
  { age: 'Age 8+ Advanced', title: 'Expression Bot',       level: 'Advanced' },
];

const IconCalendar = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>);
const IconClock   = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);
const IconKit     = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>);
const IconArrow   = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>);
const IconMail    = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>);

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '3px' };

function SeasonalPopup({ onClose }) {
  const [view, setView]           = useState('teaser');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [errors, setErrors]       = useState({});
  const [formData, setFormData]   = useState({
    childName: '', parentName: '', phone: '', email: '',
    course: '', batch: '', message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.childName) newErrors.childName = 'Required';
    if (!formData.phone)     newErrors.phone     = 'Required';
    if (!formData.email)     newErrors.email     = 'Required';
    if (!formData.course)    newErrors.course    = 'Please select a course';
    if (!formData.batch)     newErrors.batch     = 'Please select a batch';
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }

    setLoading(true);
    try {
      await fetch('http://localhost:5000/api/canada-camp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType:   'canada-summer-camp',
          childName:  formData.childName,
          parentName: formData.parentName,
          phone:      formData.phone,
          email:      formData.email,
          course:     formData.course,
          batch:      formData.batch,
          message:    formData.message,
        }),
      });
      setSubmitted(true);
    } catch (err) {
      alert('Something went wrong. Please email us directly at ibotsalberta@gmail.com');
    }
    setLoading(false);
  };

  return (
    <div className="sp__overlay">
      <div className="sp__box">

        {/* Blinking live bar */}
        <div className="sp__live-bar">
          <span className="sp__live-dot" />
          <span className="sp__live-text">Now Enrolling — Canada Summer Camp 2026</span>
          <span className="sp__live-dot" />
        </div>

        {/* Close */}
        <button className="sp__close" onClick={onClose} aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        {/* Header — always visible */}
        <div className="sp__header">
          <div className="sp__header-left">
            <div className="sp__canada-flag">
              <svg viewBox="0 0 60 30" width="48" height="24" xmlns="http://www.w3.org/2000/svg">
                <rect width="60" height="30" fill="#fff"/>
                <rect width="15" height="30" fill="#d52b1e"/>
                <rect x="45" width="15" height="30" fill="#d52b1e"/>
                <path d="M30 6 l2 5h5l-4 3 1.5 5L30 16l-4.5 3 1.5-5-4-3h5z" fill="#d52b1e"/>
              </svg>
            </div>
            <div>
              <p className="sp__location">ibots Alberta · Canada</p>
              <h2 className="sp__title">Summer Camp <span>2026</span></h2>
            </div>
          </div>
          <div className="sp__header-pills">
            <span className="sp__pill"><IconCalendar /> July – Aug 2026</span>
            <span className="sp__pill"><IconClock /> 5 Days · 4 hrs/day</span>
            <span className="sp__pill sp__pill--gold"><IconKit /> Kit Included</span>
          </div>
        </div>

        {/* ── SCREEN 1: TEASER ── */}
        {view === 'teaser' && (
          <div className="sp__teaser">
            <p className="sp__teaser-text">
              ibots is launching its first Summer Camp in Alberta, Canada — a hands-on robotics
              programme for children aged 6 and above. Multiple weekly batches available through
              July – August 2026.
            </p>
            <div className="sp__teaser-highlights">
              {[['3','Courses'],['8','Batches'],['Age 6+','Eligible'],['Jul–Aug','Duration']].map(([num, label], i) => (
                <React.Fragment key={i}>
                  <div className="sp__highlight">
                    <span className="sp__highlight-num">{num}</span>
                    <span className="sp__highlight-label">{label}</span>
                  </div>
                  {i < 3 && <div className="sp__highlight-div" />}
                </React.Fragment>
              ))}
            </div>
            <button className="sp__know-more-btn" onClick={() => setView('details')}>
              View Programme Details <IconArrow />
            </button>
          </div>
        )}

        {/* ── SCREEN 2: DETAILS ── */}
        {view === 'details' && (
          <div className="sp__details">
            <p className="sp__section-label">Courses Offered</p>
            <div className="sp__courses">
              {COURSES.map((c, i) => (
                <div key={i} className="sp__course-card">
                  <div className="sp__course-top">
                    <span className="sp__course-age">{c.age}</span>
                    <span className="sp__course-level">{c.level}</span>
                  </div>
                  <p className="sp__course-title">{c.title}</p>
                </div>
              ))}
            </div>

            <p className="sp__section-label"><IconCalendar /> Batch Schedule — Monday to Friday</p>
            <div className="sp__batches">
              {BATCHES.map((b, i) => (
                <div key={i} className="sp__batch">
                  <span className="sp__batch-num">Batch {i + 1}</span>
                  <span className="sp__batch-date">{b}</span>
                </div>
              ))}
            </div>

            <div className="sp__info-row">
              <div className="sp__info-item"><IconClock /><span>5 Days · 4 Hours / Day</span></div>
              <div className="sp__info-item"><IconKit /><span>Kit included — yours to take home</span></div>
            </div>

            <div className="sp__cta-row">
              <button className="sp__back-btn" onClick={() => setView('teaser')}>← Back</button>
              <button className="sp__book-btn" onClick={() => setView('form')}>
                <IconMail /> Book Your Spot
              </button>
            </div>
            <p className="sp__cta-note">Click above to fill in your booking details</p>
          </div>
        )}

        {/* ── SCREEN 3: BOOKING FORM ── */}
        {view === 'form' && !submitted && (
          <div className="sp__details">
            <div className="sp__form-section">
              <p className="sp__section-label"><IconMail /> Booking Details</p>
              <div className="sp__form-grid">
                <div className="sp__form-group">
                  <label>Child's Name *</label>
                  <input name="childName" value={formData.childName} onChange={handleChange}
                    placeholder="Child's full name" className="sp__input" />
                  {errors.childName && <p style={errStyle}>{errors.childName}</p>}
                </div>
                <div className="sp__form-group">
                  <label>Parent's Name</label>
                  <input name="parentName" value={formData.parentName} onChange={handleChange}
                    placeholder="Parent's name" className="sp__input" />
                </div>
                <div className="sp__form-group">
                  <label>Phone *</label>
                  <input name="phone" value={formData.phone} onChange={handleChange}
                    placeholder="+1 or +91 number" className="sp__input" />
                  {errors.phone && <p style={errStyle}>{errors.phone}</p>}
                </div>
                <div className="sp__form-group">
                  <label>Email *</label>
                  <input name="email" value={formData.email} onChange={handleChange}
                    placeholder="you@example.com" className="sp__input" />
                  {errors.email && <p style={errStyle}>{errors.email}</p>}
                </div>
                <div className="sp__form-group">
                  <label>Select Course *</label>
                  <select name="course" value={formData.course} onChange={handleChange} className="sp__input">
                    <option value="">Choose course...</option>
                    <option value="Age 6+ — Dog Bot & Cradle Bot">Age 6+ — Dog Bot & Cradle Bot</option>
                    <option value="Age 8+ Basic — Walking Bot">Age 8+ Basic — Walking Bot</option>
                    <option value="Age 8+ Advanced — Expression Bot">Age 8+ Advanced — Expression Bot</option>
                  </select>
                  {errors.course && <p style={errStyle}>{errors.course}</p>}
                </div>
                <div className="sp__form-group">
                  <label>Preferred Batch *</label>
                  <select name="batch" value={formData.batch} onChange={handleChange} className="sp__input">
                    <option value="">Choose batch...</option>
                    {BATCHES.map((b, i) => (
                      <option key={i} value={b}>Batch {i + 1} — {b}</option>
                    ))}
                  </select>
                  {errors.batch && <p style={errStyle}>{errors.batch}</p>}
                </div>
                <div className="sp__form-group sp__form-group--full">
                  <label>Message (optional)</label>
                  <textarea name="message" value={formData.message} onChange={handleChange}
                    placeholder="Any questions or special requirements..."
                    className="sp__input" rows={2} style={{ resize: 'vertical' }} />
                </div>
              </div>
            </div>

            <div className="sp__cta-row">
              <button className="sp__back-btn" onClick={() => setView('details')}>← Back</button>
              <button className="sp__book-btn" onClick={handleSubmit} disabled={loading}>
                <IconMail /> {loading ? 'Submitting...' : 'Confirm Booking'}
              </button>
            </div>
            <p className="sp__cta-note">
              Your booking will be saved and forwarded to <strong>ibotsalberta@gmail.com</strong>
            </p>
          </div>
        )}

        {/* ── SCREEN 4: SUCCESS ── */}
        {submitted && (
          <div className="sp__success">
            <div className="sp__success-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h3>Booking Confirmed!</h3>
            <p>Your booking has been saved and the ibots Alberta team has been notified at <strong>ibotsalberta@gmail.com</strong>. They will contact you shortly to confirm your spot.</p>
            <button className="sp__know-more-btn" onClick={onClose}>Close</button>
          </div>
        )}

      </div>
    </div>
  );
}

export default SeasonalPopup;
